import { Navigate, useNavigate, useSearchParams } from 'react-router';
import { SignInScreen, safeReturnTo, useSession } from '@platform/app-kit';
import { AUTH_FRAME } from '../shell/brand.ts';
import { useDocumentTitle } from '../shell/document-title.ts';

/**
 * `/login` — email and password over SRP. No workspace, no invitation: a personal account has
 * one tenant, chosen by the token. Someone who never entered the emailed sign-up code confirms
 * it right here. After sign-in: the return path; `/` sends a person with no plan yet to
 * `/subscribe`.
 */
export function LoginPage() {
  const { status } = useSession();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const returnTo = safeReturnTo(params.get('returnTo'));
  const confirmed = params.get('confirmed') === '1';
  useDocumentTitle('Sign in');

  if (status === 'authenticated') return <Navigate to={returnTo} replace />;

  return (
    <SignInScreen
      frame={AUTH_FRAME}
      arrival={{ email: params.get('email'), tenant: null, temporaryPassword: null }}
      forgotPasswordHref="/forgot-password"
      signUpHref="/signup"
      signUpLabel="Create an account"
      {...(confirmed ? { notice: 'Your email is confirmed. Sign in to continue.' } : {})}
      onSignedIn={() => void navigate(returnTo, { replace: true })}
    />
  );
}
